import React, { useEffect, useState } from "react";
import "./AddressSection.css";

const AddressSection = ({ address, saving, onSave }) => {
  const [formData, setFormData] = useState({
    doorNo: "",
    street: "",
    landmark: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    latitude: "",
    longitude: "",
    deliveryRadius: 5,
    serviceType: "Both",
  });

  useEffect(() => {
    if (address) {
      setFormData({
        doorNo: address.doorNo || "",
        street: address.street || "",
        landmark: address.landmark || "",
        area: address.area || "",
        city: address.city || "",
        state: address.state || "",
        pincode: address.pincode || "",
        latitude: address.latitude || "",
        longitude: address.longitude || "",
        deliveryRadius: address.deliveryRadius || 5,
        serviceType: address.serviceType || "Both",
      });
    }
  }, [address]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="address-card">

      <div className="card-header">
        <div>
          <h3>📍 Business Address</h3>
          <p>
            Manage your business location and delivery coverage.
          </p>
        </div>

        <span className="address-badge">
          Active
        </span>
      </div>

      <form onSubmit={submitHandler}>

        <div className="address-grid">

          <div className="form-group">
            <label>Door / House No</label>
            <input
              type="text"
              name="doorNo"
              value={formData.doorNo}
              onChange={handleChange}
              placeholder="Door No"
            />
          </div>

          <div className="form-group">
            <label>Street</label>
            <input
              type="text"
              name="street"
              value={formData.street}
              onChange={handleChange}
              placeholder="Street"
            />
          </div>

          <div className="form-group">
            <label>Landmark</label>
            <input
              type="text"
              name="landmark"
              value={formData.landmark}
              onChange={handleChange}
              placeholder="Nearby Landmark"
            />
          </div>

          <div className="form-group">
            <label>Area</label>
            <input
              type="text"
              name="area"
              value={formData.area}
              onChange={handleChange}
              placeholder="Area"
            />
          </div>

          <div className="form-group">
            <label>City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="City"
            />
          </div>

          <div className="form-group">
            <label>State</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              placeholder="State"
            />
          </div>

          <div className="form-group">
            <label>Pincode</label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              placeholder="560001"
            />
          </div>

          <div className="form-group">
            <label>Delivery Radius (KM)</label>
            <input
              type="number"
              name="deliveryRadius"
              value={formData.deliveryRadius}
              onChange={handleChange}
              min="1"
            />
          </div>

          <div className="form-group">
            <label>Latitude</label>
            <input
              type="text"
              name="latitude"
              value={formData.latitude}
              onChange={handleChange}
              placeholder="Latitude"
            />
          </div>

          <div className="form-group">
            <label>Longitude</label>
            <input
              type="text"
              name="longitude"
              value={formData.longitude}
              onChange={handleChange}
              placeholder="Longitude"
            />
          </div>

          <div className="form-group full-width">
            <label>Service Type</label>

            <select
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
            >
              <option value="Both">Delivery + Pickup</option>
              <option value="Delivery">Delivery Only</option>
              <option value="Pickup">Pickup Only</option>
            </select>
          </div>

        </div>

        <div className="address-footer">

          <button
            type="button"
            className="location-btn"
          >
            📍 Choose on Map
          </button>

          <button
            className="address-btn"
            type="submit"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Address"}
          </button>

        </div>

      </form>

    </div>
  );
};

export default AddressSection;